import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { API } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Newspaper, ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/posts")
      .then((r) => setPosts(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-ink grain">
      <Navbar />
      <div className="pt-28 px-6 sm:px-12 lg:px-20 max-w-5xl mx-auto pb-24" data-testid="blog-listing-page">
        <div className="flex items-center gap-3 mb-2">
          <Newspaper className="w-6 h-6 text-gold" />
          <p className="text-xs uppercase tracking-widest text-terracotta font-semibold">Cinevoya journal</p>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-black mb-3">News &amp; dispatches</h1>
        <p className="text-foreground/55 max-w-2xl text-sm">Behind-the-scenes notes from the platform, festival updates, and stories from the filmmakers shaping African short cinema.</p>

        <div className="mt-12">
          {loading ? (
            <p className="text-foreground/45 text-sm">Loading…</p>
          ) : posts.length === 0 ? (
            <div className="rounded-2xl border border-white/10 bg-surface/40 p-10 text-center" data-testid="blog-empty-state">
              <p className="text-foreground/55">No dispatches yet. Check back soon.</p>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((p) => (
                <Link
                  to={`/blog/${p.slug}`}
                  key={p.id}
                  className="group rounded-2xl overflow-hidden border border-white/10 bg-surface hover:border-terracotta/40 transition-colors flex flex-col"
                  data-testid={`blog-card-${p.slug}`}
                >
                  <div className="aspect-[16/9] bg-ink/60 overflow-hidden">
                    {p.image_url ? (
                      <img
                        src={`${API}${p.image_url}`}
                        alt=""
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <Newspaper className="w-10 h-10 text-foreground/15" />
                      </div>
                    )}
                  </div>
                  <div className="p-5 flex-1 flex flex-col">
                    <p className="text-[11px] uppercase tracking-widest text-foreground/45">
                      {p.published_at ? new Date(p.published_at).toLocaleDateString("en-NG", { day: "numeric", month: "short", year: "numeric" }) : ""}
                    </p>
                    <h2 className="font-display text-xl font-bold mt-1 leading-snug group-hover:text-terracotta transition-colors">
                      {p.title}
                    </h2>
                    {p.excerpt && (
                      <p className="text-sm text-foreground/65 mt-2 line-clamp-3 flex-1">{p.excerpt}</p>
                    )}
                    <div className="mt-3 inline-flex items-center gap-1 text-sm text-terracotta">
                      Read <ArrowRight className="w-3.5 h-3.5" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
